// initial values from:
// - https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types
// - https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types

// common extension: mime type
export enum DocumentDataType {
    DOC = 'application/msword',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF = 'application/pdf',
    APNG = 'image/apng',
    AVIF = 'image/avif',
    GIF = 'image/gif',
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    SVG = 'image/svg+xml',
    WEBP = 'image/webp',
    XLS = 'application/vnd.ms-excel',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    CSV = 'text/csv',
    TXT = 'text/plain',
}

export const DocumentDataTypeExtension: Record<DocumentDataType, string> = {
    [DocumentDataType.DOC]: '.doc',
    [DocumentDataType.DOCX]: '.docx',
    [DocumentDataType.PDF]: '.pdf',
    [DocumentDataType.APNG]: '.apng',
    [DocumentDataType.AVIF]: '.avif',
    [DocumentDataType.GIF]: '.gif',
    [DocumentDataType.JPEG]: '.jpeg',
    [DocumentDataType.PNG]: '.png',
    [DocumentDataType.SVG]: '.svg',
    [DocumentDataType.WEBP]: '.webp',
    [DocumentDataType.XLS]: '.xls',
    [DocumentDataType.XLSX]: '.xlsx',
    [DocumentDataType.CSV]: '.csv',
    [DocumentDataType.TXT]: '.txt',
};
